export const GET_ALL_STORE_CATEGORIES = "GET_ALL_STORE_CATEGORIES";
export const GET_ALL_STORES = 'GET_ALL_STORES';
export const GET_ALL_PENDING_STORES = 'GET_ALL_PENDING_STORES';
export const GET_STORE_ITEM_URLGET_SINGLE_STORE = 'GET_SINGLE_STORE';
export const GET_STORE_ITEM_CATEGORIES = "GET_STORE_ITEM_CATEGORIES";
export const GET_STORE_ITEMS = "GET_STORE_ITEMS";
export const GET_STORE_ADDON_CATEGORIES = "GET_STORE_ADDON_CATEGORIES";
export const STORE_BULK_UPLOAD = "STORE_BULK_UPLOAD";
export const ACCEPT_STORE = "ACCEPT_STORE";
export const GET_ITEM_ADDON_CATEGORY = "GET_ITEM_ADDON_CATEGORY";
export const UPDATE_ITEM_ADDON_CATEGORY = "UPDATE_ITEM_ADDON_CATEGORY";
export const GET_STORE_ITEM = "GET_STORE_ITEM";
export const GET_SINGLE_STORE = "GET_SINGLE_STORE";
export const GET_STORE_SORT_ITEMS = "GET_STORE_SORT_ITEMS";
export const GET_STORE_SORT_ITEM_CATEGORIES = "GET_STORE_SORT_ITEM_CATEGORIES";
